export default function CTASection() {
  return (
    <section className="relative w-full py-28 md:py-36 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Energetic%20colorful%20flat%20lay%20product%20photography%20with%20vibrant%20sneakers%20in%20electric%20blue%20neon%20green%20and%20hot%20pink%2C%20mixed%20with%20designer%20caps%20gold%20chain%20necklaces%20and%20statement%20sunglasses%20arranged%20dynamically%20on%20bright%20white%20surface%2C%20bold%20colorful%20shadows%20from%20overhead%20studio%20lighting%2C%20festival%20streetwear%20aesthetic%2C%20high%20saturation%20pop%20art%20inspired%20editorial%20style%2C%20playful%20energetic%20composition%20with%20movement%20and%20rhythm%2C%20fashion%20editorial%20with%20maximum%20visual%20impact%2C%20glossy%20magazine%20quality%20with%20punchy%20contrast&width=1920&height=900&seq=cta-hipobuy-v2-2025&orientation=landscape"
          alt="Hipobuy Spreadsheet product background"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>

      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12">
          <div className="max-w-lg">
            <h2 className="text-5xl md:text-7xl font-bold text-white font-heading leading-none">
              millions of finds,<br />one hub
            </h2>
          </div>

          <div className="flex flex-col gap-6">
            <p className="text-base md:text-lg text-white/80 font-body max-w-sm leading-relaxed">
              Ready to transform your product discovery experience? Access the complete Hipobuy Spreadsheet resource now.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap w-fit"
            >
              <span>buy it now</span>
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-900">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}